import React from 'react';
import io from 'dojo/io-query';
import { mapStore } from 'stores/MapStore';
import { reportStore } from 'stores/ReportStore';
import { criteriaStore } from 'stores/CriteriaStore';

const Utilities = {
  createHash: () => {
    const mapStoreState = mapStore.getState();
    const reportStoreState = reportStore.getState();
    const criteriaStoreState = criteriaStore.getState();

    let visibleLoad = '';
    const selectedLoads = [];
    reportStoreState.loads.forEach((load) => {
      if (load.checked === 'checked') {
        selectedLoads.push(load.label);
      }
      if (load.visible === true) {
        visibleLoad = load.label;
      }
    });
    //Parameters - lat, lon, zoom, risk, soil, standardsVersion, measurementType, loads, visibleLoad
    let parameters = {
      lat: criteriaStoreState.latitude, // latitude
      lon: criteriaStoreState.longitude, // longitude
      z: mapStoreState.map.getZoom(), // Map current zoom
      r: criteriaStoreState.riskLevel, // risk level
      sc: criteriaStoreState.soilClass, // soil class
      sv: criteriaStoreState.standardsVersion, // standards version
      m: criteriaStoreState.measurement, // measurement type
      l: selectedLoads, // selected loads
      v: visibleLoad, // visible load
    };
    return `${window.location.href}#${io.objectToQuery(parameters)}`;
  },

  romanize: (num) => {
    if (typeof num !== 'number') {
      return NaN;
    }

    let digits = String(+num).split(''),
      key = [
        '',
        'C',
        'CC',
        'CCC',
        'CD',
        'D',
        'DC',
        'DCC',
        'DCCC',
        'CM',
        '',
        'X',
        'XX',
        'XXX',
        'XL',
        'L',
        'LX',
        'LXX',
        'LXXX',
        'XC',
        '',
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
      ],
      roman = '',
      i = 3;
    while (i--) {
      roman = (key[+digits.pop() + i * 10] || '') + roman;
    }
    return Array(+digits.join('') + 1).join('M') + roman;
  },

  //Only converts feet to meters and vice versa
  standardsConversionFeetMeters(inputValue, inputType, outputType) {
    if (inputType === outputType) {
      return Number(inputValue);
    }
    if (outputType === 'si') {
      return Number(inputValue) * 0.3048;
    }
    if (outputType === 'imperial') {
      return Number(inputValue) / 0.3048;
    }
  },

  standardsConversionInchesMMs(inputValue, inputType, outputType) {
    if (inputType === outputType) {
      return Number(inputValue);
    }
    if (outputType === 'si') {
      return Number(inputValue) * 25.4;
    }
    if (outputType === 'imperial') {
      return Number(inputValue) / 25.4;
    }
  },

  snowConvserion(inputValue, inputType, outputType) {
    if (inputType === outputType) {
      return Number(inputValue);
    }
    if (outputType === 'si') {
      return (Number(inputValue) * 0.04788).toFixed(2);
    }
    if (outputType === 'imperial') {
      return Number(inputValue) / 0.04788;
    }
  },

  convserionMilesMeterSecond(inputValue, inputType, outputType) {
    let output = Number(inputValue);

    if (inputType === outputType) {
      return output;
    }
    if (outputType === 'si') {
      return output * 0.44704;
    }
    if (outputType === 'imperial') {
      return output / 0.44704;
    }
  },

  conversionTemperature(inputValue, inputType, outputType) {
    if (inputType === outputType) {
      return Number(inputValue);
    }
    if (outputType === 'si') {
      return ((Number(inputValue) - 32) * 5) / 9;
    }
    if (outputType === 'imperial') {
      return (Number(inputValue) * 9) / 5 + 32;
    }
  },

  checkIfSquaredJsx(inputValue) {
    if (typeof inputValue === 'string' && inputValue.includes('^2')) {
      let pos = inputValue.indexOf('^2');
      let bef = inputValue.substring(0, pos);
      let aft = inputValue.substring(pos + 3).trim(); //3 derives from length of ^2 and plus 1 to start after and remove spaces
      return (
        <span>
          {bef}
          <sup>2</sup>
          {'\u00A0'}
          {aft}
        </span>
      );
    } else if (typeof inputValue === 'string' && inputValue.includes('V^T')) {
      let pos = inputValue.indexOf('^T');
      let bef = inputValue.substring(0, pos);
      let aft = inputValue.substring(pos + 3).trim(); //3 derives from length of ^2 and plus 1 to start after and remove spaces
      return (
        <span>
          {bef}
          <sub>T </sub>
          {aft}
        </span>
      );
    } else {
      return inputValue;
    }
  },

  getLetter(index) {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return alphabet[index];
  },

  timeLeftInDaysSort(a, b) {
    if (a.timeLeftInDays < b.timeLeftInDays) {
      return 1;
    }
    if (a.timeLeftInDays > b.timeLeftInDays) {
      return -1;
    }
    return 0;
  },
};

export const romanize = Utilities.romanize;
export const standardsConversionFeetMeters = Utilities.standardsConversionFeetMeters;
export const standardsConversionInchesMMs = Utilities.standardsConversionInchesMMs;
export const snowConvserion = Utilities.snowConvserion;
export const convserionMilesMeterSecond = Utilities.convserionMilesMeterSecond;
export const conversionTemperature = Utilities.conversionTemperature;
export const checkIfSquaredJsx = Utilities.checkIfSquaredJsx;
export const getLetter = Utilities.getLetter;
export const timeLeftInDaysSort = Utilities.timeLeftInDaysSort;
export const createHash = Utilities.createHash;
